/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

// project imports
import {
    PersonalInfo,
    ChangePassword,
    TaxExemptions,
    NotificationPreferences,
    Listing,
    InvoiceList,
    InvoiceView,
    PaymentMethodsList,
    PaymentMethodsAdd,
    PersonalInterest,
    VipMember,
    ThankYou,
    InvoiceRaView,
    InvoiceGdView,
    
} from 'features/components/base/auth-pages/MyAccount';
import { Watching, Bidding, Won, NotWon, FavoriteLocation } from 'features/components/base/auth-pages';
import DeleteAccount from 'features/components/base/auth-pages/MyAccount/delete-account/DeleteAccount';
import AuctionSPSale from 'features/components/calendar/AuctionSPSale';
import WorthPoint from 'features/components/calendar/membership-benefits/worthpoint';
import Mir from 'features/components/base/auth-pages/MyAccount/mir/Mir';
import guranteedDelivery from 'features/components/calendar/membership-benefits/guaranteedDelivery';
import AlzheimersFoundation from 'features/components/calendar/membership-benefits/AlzheimersFoundation';
import memberserivce from 'features/components/calendar/membership-benefits/MemberService';
import myPrimerAccount from 'features/components/calendar/membership-benefits/MyPrimerAccount';
import premierFaqs from 'features/components/calendar/membership-benefits/PremierFaqs';
import MakeitReturnable from 'features/components/calendar/membership-benefits/MakeItReturnable';
import PMAdvisor from 'features/components/calendar/membership-benefits/PMAdvisor';
import AuctionSPSItems from 'features/components/calendar/AuctionSPSItems';
import AuctionSPSItem from 'features/components/calendar/AuctionSPSItem';
import VipPlan from 'features/components/base/auth-pages/MyAccount/vip-member/VipPlan';
import DG from 'features/components/base/auth-pages/MyAccount/DG/DG';
import ShippedItems from 'features/components/base/auth-pages/MyAccount/invoice/ShippedItems';
import membershipThankYou from 'features/components/calendar/membership-benefits/membershipThankYou';
import AutoRenew from 'features/components/calendar/membership-benefits/AutoRenew';
import PremierMemberInvoiceView from 'features/components/calendar/membership-benefits/PremierMemberInvoiceView';
import CtbidsThankYou from 'features/components/calendar/membership-benefits/CtbidsThankYou';
import { isAuthorized } from 'shared/settings/auth';
/**
 * routing for my-account components
 * 
 * @param props
 * 
 * @return routing for buyers components
 * 
**/

class MyAccountRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={`/my-account/my-info/personal-info`} component={PersonalInfo} />
                <Route exact path={`/my-account/ctbids/thankyou`} component={CtbidsThankYou} />
                <Route exact path={`/my-account/join-premier-member`} component={VipMember} />
                <Route exact path={`/my-account/my-info/personal-interests`} component={PersonalInterest} />
                <Route exact path={`/my-account/my-info/thank-you`} component={ThankYou} />
                <Route exact path={`/my-account/my-info/delete-account`} component={DeleteAccount} />
                <Route exact path={`/my-account/my-info/change-password`} component={ChangePassword} />
                <Route exact path={`/my-account/my-info/tax-exemptions`} component={TaxExemptions} />
                <Route exact path={`/my-account/my-info/payment-methods`} component={PaymentMethodsList} />
                <Route exact path={`/my-account/my-info/payment-methods/add`} component={PaymentMethodsAdd} />
                <Route exact path={`/my-account/notification-preferences`} component={NotificationPreferences} />
                <Route exact path={`/my-account/listing`} component={Listing} />
                <Route exact path={`/my-account/invoice`} component={InvoiceList} />
                <Route exact path={`/my-account/invoice/:invoiceId/view`} component={InvoiceView} />
                <Route exact path={`/my-account/invoice/ra/:invoiceId/view`} component={InvoiceRaView} />
                <Route exact path={`/my-account/invoice/dg/:invoiceId/view`} component={InvoiceGdView} />
                <Route exact path={`/my-account/invoice/shipped-items`} component={ShippedItems} />
                <Route exact path={`/my-account/favorite-locations`} component={FavoriteLocation} />
                <Route exact path={`/my-account/mir`} component={Mir} />
                <Route exact path={`/my-account/gd`} component={DG} />

                <Route exact path={['/my-account/watching', `/my-account/watching/:saleId/item/:itemId`]}
                    component={Watching} />
                <Route exact path={['/my-account/bidding', `/my-account/bidding/:saleId/item/:itemId`]}
                    component={Bidding} />
                <Route exact path={['/my-account/won', `/my-account/won/:saleId/item/:itemId`]}
                    component={Won} />
                <Route exact path={['/my-account/not-won', `/my-account/not-won/:saleId/item/:itemId`]}
                    component={NotWon} />
                <Route exact path={`/my-account/premier-plan`} component={VipPlan} />
                {
                    isAuthorized() ?
                        this?.props?.user?.membershipCompleted ?
                            <>
                                <Route exact path={`/my-account/premier/auction-sneak-peak`} component={AuctionSPSale} />
                                <Route exact path={`/my-account/premier/auction-sneak-peak-sale/:saleId`} component={AuctionSPSItems} />
                                <Route exact path={`/my-account/premier/auction-sneak-peak-item/:saleId/item/:itemId`} component={AuctionSPSItem} />
                                <Route exact path={`/my-account/premier/delivery-guarantee`} component={guranteedDelivery} />
                                <Route exact path={`/my-account/premier/alzheimers-foundation`} component={AlzheimersFoundation} />
                                <Route exact path={`/my-account/premier/member-benefits`} component={memberserivce} />
                                <Route exact path={`/my-account/premier/premier-membership`} component={memberserivce} />
                                <Route exact path={`/my-account/premier/premier-account`} component={myPrimerAccount} />
                                <Route exact path={`/my-account/premier/advisor`} component={PMAdvisor} />
                                <Route exact path={`/my-account/premier/total-access`} component={premierFaqs} />
                                <Route exact path={`/my-account/premier-member/invoice/view`} component={PremierMemberInvoiceView} />
                                <Route exact path={`/my-account/premier/worthpoint`} component={WorthPoint} />
                                <Route exact path={`/my-account/premier/thankyou`} component={membershipThankYou} />
                                {this.props.user.suspensionstatus != "ALL" && (<Route exact path="/my-account/autorenew" component={AutoRenew} />)}          
                            </>
                            : <Redirect to="/my-account/join-premier-member" />
                        :
                        <Redirect to="/" />
                }
                <Redirect to="/" />
            </Switch>
        );
    }
}
export default connect(state => state)(MyAccountRouter);